import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core/';
import { useTranslation } from 'react-i18next';
import { UserOption } from '../models/user';

interface IProps {
  value: string;
  users: UserOption[];
  onUserSelect: (value: string) => void;
  allowNotSelected?: boolean;
  notSelectedLabel?: string;
  disabled?: boolean;
  cssClass?: string;
  fullWidth?: boolean;
  labelText?: string;
}

const UserSelect = ({
  value,
  onUserSelect,
  allowNotSelected,
  notSelectedLabel,
  users,
  cssClass,
  fullWidth,
  labelText,
  disabled
}: IProps) => {
  const { t } = useTranslation();

  const handleValueChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as string;

    //callback
    onUserSelect(value);
  };

  return (
    <FormControl className={cssClass} fullWidth={fullWidth} disabled={disabled}>
      <InputLabel id="user-select-lbl" shrink={allowNotSelected && value === '' ? true : undefined}>
        {labelText || t('f-user')}
      </InputLabel>
      <Select
        labelId="user-select-lbl"
        id="user-select"
        value={value}
        onChange={handleValueChange}
        displayEmpty={allowNotSelected}
        renderValue={(selected) =>
          selected === '' && allowNotSelected
            ? (notSelectedLabel ?? t('f-user-not-spec'))
            : (users.find((user) => user.id === selected)?.name ?? '')
        }
      >
        {allowNotSelected && (
          <MenuItem divider value={''} key={'no-usr'}>
            {notSelectedLabel ?? t('f-user-not-spec')}
          </MenuItem>
        )}

        {users.map((user) => (
          <MenuItem value={user.id} key={user.id}>
            {user.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default UserSelect;
